 
 

export default {
    test: function test () {
        return '公共方法';
    },
}